module.exports = __webpack_public_path__ + "static/media/SAS Chat Tone 1.04c9be42.mp3";